import React, { useState } from 'react';
import ChatHeader from '../molecules/ChatHeader';
import LarpBar from '../molecules/LarpBar';
import MessageList from '../organisms/MessageList';
import ChatFooter from '../molecules/ChatFooter';
import ApiKeyForm from '../molecules/ApiKeyForm';
import Typography from '../atoms/Typography';
import { useChat } from '../../context/ChatContext';
import './ChatTemplate.css';

const ChatTemplate = ({
  onBackClick,
  teacherName = 'Super Mandarin Conversation',
  vocabularyOpen = false,
  onToggleVocabulary,
  missionsOpen = false,
  onToggleMissions,
}) => {
  const [larpOpen, setLarpOpen] = useState(false);
  const {
    messages,
    userAvatar,
    teacherAvatar,
    isInitialized,
    isLoading,
    error,
    isSpeaking,
    hasApiKey,
    chatRole,
    setChatRole,
  } = useChat();

  return (
    <div className="chat-template">
      <ChatHeader
        name={teacherName}
        status="online"
        avatarSrc={teacherAvatar}
        onBackClick={onBackClick}
        vocabularyOpen={vocabularyOpen}
        onToggleVocabulary={onToggleVocabulary}
        missionsOpen={missionsOpen}
        onToggleMissions={onToggleMissions}
        larpOpen={larpOpen}
        onToggleLarp={() => setLarpOpen((open) => !open)}
      />
      {larpOpen && <LarpBar role={chatRole} onSelect={setChatRole} />}

      <div className="chat-content">
        {!isInitialized && (
          <div className="chat-api-key-container glass-card">
            {!hasApiKey ? (
              <div className="env-instructions">
                <Typography variant="subtitle1" color="primary" className="heading-md text-gradient">
                  API Configuration Required
                </Typography>
                <Typography variant="body2" color="dark">
                  ⚠️ For security, API keys should be handled by a backend server.
                </Typography>
                <div className="code-block">
                  <code>
                    # For local development only, create .env.local:<br />
                    REACT_APP_CLERK_PUBLISHABLE_KEY=pk_test_your_clerk_key<br />
                    # Note: OpenAI API key should be in backend, not client-side
                  </code>
                </div>
                <Typography variant="body2" color="dark">
                  See SECURITY_CRITICAL_FIXES.md for proper backend setup.
                </Typography>
              </div>
            ) : (
              <ApiKeyForm />
            )}
          </div>
        )}

        {error && (
          <div className="chat-error">
            <Typography variant="body2" color="primary">
              {error}
            </Typography>
          </div>
        )}

        {isLoading && (
          <div className="chat-loading">
            <Typography variant="body2" color="secondary">
              <span className="loading-dots">Loading</span>
            </Typography>
          </div>
        )}

        {isSpeaking && (
          <div className="chat-speaking-indicator">
            <Typography variant="caption" color="secondary">
              <span className="speaking-wave">Speaking</span>
            </Typography>
          </div>
        )}

        <MessageList
          messages={messages}
          userAvatar={userAvatar}
          teacherAvatar={teacherAvatar}
        />
      </div>

      <ChatFooter />
    </div>
  );
};

export default ChatTemplate;
